import { Flex, Typography } from "antd";
import { useTranslate } from "@refinedev/core";
import { PREFIXES } from "./constants/constants";

export const SectionHeader = ({ type }: { type: keyof typeof PREFIXES }) => {
  const t = useTranslate();
  return (
    <Flex vertical>
      <Typography.Title level={5} style={{ margin: 0 }}>
        {t(`${PREFIXES[type]}.title`)}
      </Typography.Title>
      <Typography.Text type="secondary">
        {t(`${PREFIXES[type]}.subtitle`)}
      </Typography.Text>
    </Flex>
  );
};
